import ga from '../utils/ga'
import { IExperimentsState, IExperimentState } from '../reducers/experiments'

export const reportExperimentEnrolment = ({
  experimentId,
  variant
}: {
  experimentId: string
  variant: string
}) => {
  ga('set', 'expId', experimentId)
  ga('set', 'expVar', variant)
  ga('send', {
    hitType: 'event',
    eventCategory: 'experiment',
    eventAction: 'view',
    eventLabel: experimentId,
    eventValue: variant,
    nonInteraction: true
  })
}

export const reportExperimentsDimensions = (
  experimentsState: IExperimentsState
) => {
  const isExperimentEntry = (
    entry: [string, any]
  ): entry is [string, IExperimentState] => {
    return (
      entry[1] &&
      entry[1].hasOwnProperty('variant') &&
      entry[1].hasOwnProperty('isLoadingVariant')
    )
  }
  const experimentsDimensions = Object.entries(experimentsState)
    .filter(isExperimentEntry)
    .map(([key, value]) => `${key}-${value.variant}`)

  if (experimentsDimensions.length) {
    const dimensionValue = experimentsDimensions.join(';')
    ga('set', 'dimension21', dimensionValue)
    ga('set', 'dimension22', dimensionValue)
  }
}
